import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'
import i18next from 'i18next'

const NO_VALUE = '—'

/**
 * LicenseType → 日本語ラベル変換 (OCCTO マスタ共通)。
 *
 * BG マスタ / 計画提出者マスタ / 取引先マスタ (account) で共通の短縮表記
 * (発電 / 小売 / 送配電 / DR事業者 / 自己託送) を返す。 事業者マスタ
 * (BusinessMaster) は「発電事業者」等のフル表記を使うため、 共通化せず別関数
 * (= BusinessMaster/models/labels.ts) を維持している。
 * ~/models/area/index.ts:convertAreaLabel と同じく i18next.t を module-level で bind する。
 */
export function licenseTypeLabel(value: LicenseType): string {
  const t = i18next.t.bind(i18next)
  switch (value) {
    case LicenseType.GENERATION:
      return t('page:adminOcctoMaster.licenseType.generation')
    case LicenseType.RETAIL:
      return t('page:adminOcctoMaster.licenseType.retail')
    case LicenseType.TRANSMISSION:
      return t('page:adminOcctoMaster.licenseType.transmission')
    case LicenseType.DR:
      return t('page:adminOcctoMaster.licenseType.dr')
    case LicenseType.SELF_WHEELING:
      return t('page:adminOcctoMaster.licenseType.selfWheeling')
    case LicenseType.UNSPECIFIED:
      return NO_VALUE
    default:
      return NO_VALUE
  }
}
